import { useEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { ProformaDetailClient } from "@/features/proformas/ProformaDetailClient";
import { getProforma, getTimeline } from "@/features/proformas/proformas.api";
import { useBreadcrumbContext } from "@/components/shell/BreadcrumbContext";
import { requireAccess } from "@/lib/routeAccess";

export const Route = createFileRoute("/_shell/proformas/$id")({
  beforeLoad: requireAccess(["proformas"]),
  component: ProformaDetailPage,
});

function ProformaDetailPage() {
  const { id } = Route.useParams();
  const { t } = useTranslation();
  const { setDetail } = useBreadcrumbContext();

  const proformaQ = useQuery({
    queryKey: ["proforma", id],
    queryFn: () => getProforma(id),
  });
  const timelineQ = useQuery({
    queryKey: ["proforma", id, "timeline"],
    queryFn: () => getTimeline(id),
  });

  useEffect(() => {
    setDetail(proformaQ.data?.number ?? id);
    return () => setDetail(null);
  }, [id, proformaQ.data?.number, setDetail]);

  if (proformaQ.isLoading) {
    return (
      <div className="avds-page" data-screen-label="Back-office Proforma Detail">
        <p style={{ color: "var(--text-secondary)" }}>{t("common.loading")}</p>
      </div>
    );
  }

  if (proformaQ.isError || !proformaQ.data) {
    return (
      <div className="avds-page" data-screen-label="Back-office Proforma Detail">
        <div className="t-h3">{t("common.errorTitle")}</div>
        <p style={{ color: "var(--text-secondary)", fontSize: "var(--fs-sm)", marginTop: "var(--space-2)" }}>
          {t("common.errorDesc")}
        </p>
      </div>
    );
  }

  return <ProformaDetailClient proforma={proformaQ.data} timeline={timelineQ.data ?? []} />;
}
